export default __webpack_public_path__ + "static/media/vip-icon-home-mobile-active.b5fbaf2d.webp";